import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';
import PreviewComponent from './PreviewComponent';

const IntacctAdmin = lazy(() =>
  loadingChunkRetry(() => import('./IntacctAdmin')),
);

const IntacctAdminWrapper = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PreviewComponent />}>
        <IntacctAdmin />
      </Suspense>
    </ErrorBoundary>
  );
};

export default IntacctAdminWrapper;
